import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { CpqSelectComponent, SelectType } from '../cpq-select/cpq-select.component';
import { ILookup } from '../common/interfaces/ILookup.interface';
import { DomainService } from '../common/services/domain.service';

@Component({
  selector: 'cpq-domain-select',
  templateUrl: './cpq-domain-select.component.html',
  standalone: false
})
export class CpqDomainSelectComponent implements OnInit {
  @ViewChild('selectDomain', { static: true }) selectDomain: CpqSelectComponent;
  @Output() domainChange = new EventEmitter<string>();

  public domains: Array<ILookup> = [];
  public currentSelectedDomain: string;
  public selectType = SelectType;

  private savedSelectedDomainValue: string;
  private readonly DEFAULT_DOMAIN: string = 'default';

  constructor(private domainService: DomainService) {}

  ngOnInit(): void {
    this.initDomains();
  }

  private initDomains(): void {
    this.domainService.getDomains(true).subscribe((domains: Array<ILookup>) => {
      this.domains = domains;
      this.currentSelectedDomain = this.DEFAULT_DOMAIN;
      this.savedSelectedDomainValue = this.DEFAULT_DOMAIN;
    });
  }

  onDomainChange(value: string): void {
    if (!value) {
      return;
    }
    this.savedSelectedDomainValue = value;
    this.domainChange.emit(value);
  }

  public focusout(event: FocusEvent): void {
    if (this.savedSelectedDomainValue) {
      this.currentSelectedDomain = this.savedSelectedDomainValue;
      this.selectDomain.writeValue(this.savedSelectedDomainValue);
    }
  }

  clearSelectedDomain(): void {
    if (this.currentSelectedDomain) {
      this.savedSelectedDomainValue = this.currentSelectedDomain;
    }
    this.selectDomain.deselect(true);
  }
}